export default __webpack_public_path__ + "static/media/CheckCaloriesAi.bba0d112.png";